import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class BillOfQuantitiesDbTableDefinition extends DbTableDefinition {
    tableName = 'billOfQuantitiesPositions';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT,
       databag LONGTEXT,
       hg TEXT,
       og TEXT,
       lg TEXT,
       ulg TEXT,
       boqposnr TEXT,
       baskey TEXT,
       shortname TEXT,
       amount INT(10),
       unit TEXT,
       boqid BIGINT(20),
       boqlabel TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}